import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader from './AppHeader';
import CuisineSections2 from './CuisineSections2';
import SpecialDishItems from './SpecialDishItems';
import CartToast from './CartToast';
import BottomMenu from './BottomMenu';

const MenuSection = (props) => {
    return (
        props.section.map(post =>
            <div className="item dish" key={post.id}><p className="ds">{post.name}</p></div>
        )
    );
};
  
class SpecialDish extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true, 
            LOCATION: this.props.location.pathname, 
            item_id: props.match.params.id,
            SECTION: [],
            itemIMAGE: '',
            ITEMS: [],
            ITEMS2: [],
            CLOSED: '',
            OPENS: '',
            ENDS: '',
            displayCartToast: 'N'
        };
    }

    fetchRestaurantMenu(mode,id,items) {
        var that = this;
        fetch('https://www.peepkitchen.in/peep/pwa/api/restaurantmenu_api3.php?mode='+mode+'&id='+id+'&items='+items,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            /*//Clearing the cart if restaurant is closed
            if(result.closed=='Y')
            {
                localStorage.removeItem('cartRES');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
            }*/
            
            var sections = result.section;
            let displayCartToast = 'N';
            let cart = localStorage.getItem('cartData');
            if(cart !== null && cart!=='{}')
                displayCartToast = 'Y';

            that.setState({ LOADING: false, SECTION:sections, itemIMAGE:result.item_pic, ITEMS:result.menu, ITEMS2:result.menu2, CLOSED:result.closed, OPENS:result.opens, ENDS:result.ends, displayCartToast:displayCartToast });
        });
    }

    inCartCallBack = () =>{

        let displayCartToast = 'N';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            displayCartToast = 'Y';
        //console.log(cart);
        //console.log(displayCartToast);
        var that = this;
        that.setState({ displayCartToast:displayCartToast });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }

        var restaurant_id = localStorage.getItem('REST');
        var item_id = this.state.item_id;
        this.fetchRestaurantMenu('MENU',restaurant_id,item_id);
    }
    
    render() { 

        if(localStorage.getItem('REST')==null)
        {
	        return (<Redirect to={'/map2'}/>)
        }
        
        //localStorage.removeItem("userData");
        //console.log(localStorage.getItem('userData'));

        let AppHeaderClass = 'appHeader bg-primary text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Special Dish';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';

        let props = {
            items: this.state.ITEMS,
            sections: this.state.SECTION,
            inCartCallBack: this.inCartCallBack,
            CLOSED: this.state.CLOSED,
            OPENS: this.state.OPENS
        };

        return (
            <div>
                {this.state.LOADING && <Loader /> }
                <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} />
                <div id="appCapsule">
                    {this.state.itemIMAGE!='' &&
                        <div className="section full"> 
                            <img src={this.state.itemIMAGE} alt="image" className="imaged square w-100" />
                        </div>
                    }
                    {this.state.CLOSED!='Y' && this.state.ENDS=='' && <p className="timings">{this.state.OPENS}</p>}
                    {this.state.CLOSED!='Y' && this.state.ENDS!='' && <p className="timings2">{this.state.ENDS}</p>}
                    {this.state.SECTION.length>0 && <CuisineSections2 {...props} /> }
                    <div className="section full mt-2 mb-2">
                        {/*<div className="section-title">{this.state.SECTION}</div>
                        <p className="short-disp">Speciality Dish for special occasion</p>*/}
                        <ul className="listview image-listview media">
                            <SpecialDishItems {...props} />
                        </ul>
                    </div>
                    <p className="conditions">*Actual dish may differ from the images displayed</p>
                    <br/>
                </div>
                {this.state.CLOSED=='Y' && 
                    <div id="toast-1" class="toast-box toast-top bg-warning show" style={{'padding': '6px', 'minHeight': '22px !important'}}>
                        <div class="in">
                            <div class="text">{this.state.OPENS}</div>
                        </div>
                    </div>
                }
                {this.state.displayCartToast=='Y' && <CartToast items={this.state.ITEMS2} />}
                <BottomMenu LOCATION={this.state.LOCATION} />
            </div>
        );
    }
}
      
export default SpecialDish;


// WEBPACK FOOTER //
// ./src/components/SpecialDish.js